export default __webpack_public_path__ + "static/media/kendra-wiswell.50b74012.PNG";